import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      children: [
        {
          path: "/",
          name: "hello",
          props: true,
          component: () =>
            import(/* webpackChunkName: "talks" */ "./components/Hello.vue")
        },
        {
          path: "talks",
          name: "talks",
          props: true,
          component: () =>
            import(/* webpackChunkName: "talks" */ "./components/Talks.vue")
        },
        {
          path: "exhibitions",
          name: "exhibitions",
          props: true,
          component: () =>
            import(/* webpackChunkName: "exhibitions" */ "./components/Exhibitions.vue")
        },
        {
          path: "stories",
          name: "stories",
          props: true,
          component: () =>
            import(/* webpackChunkName: "stories" */ "./components/Stories.vue")
        },
        {
          path: "contact",
          name: "contact",
          props: true,
          component: () =>
            import(/* webpackChunkName: "contact" */ "./components/Contact.vue")
        }
      ]
    }
  ]
});
